<div class="image-container" [style.max-width.px]="width()" [style.height.px]="height()">
  @if (url()) {
    <img class="image" [src]="url()" alt="photo" />
  }
</div>
